import { render } from "./SignUp.vue?vue&type=template&id=3144321c&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=3144321c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3144321c"

export default script